import { AssetConfig } from "../index";

export const SectionAssetConfig: AssetConfig = {
    sectionName: {type: "STRING",required: true,editable: true,label: "Name",rank: 1},
    areaSizeHectares: {type: "NUMBER", required: true,editable: true,label: "Area size",rank: 2},
    isActive: {type: "BOOLEAN",required: true,editable: true,label: "Active",rank: 2},
}